import { httpClient } from './http-client';

export const getLegislation = async () => {
  try {
    const response = await httpClient.get('api/page_files.php');
    return response.data;
  } catch (error) {
    throw new Error('Error fetching files list');
  }
};
